<template>
	<div id="PageNotFound">
		404 PAGINA NO ENCONTRADA
	</div>
</template>

<script>
	export default {
		name: 'PageNotFound'
	}
</script>

<style lang="scss">
</style>
